import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { profileData } from '../data/mock';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const fullText = profileData.title;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + fullText[index]);
        setIndex(index + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [index, fullText]);

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative bg-slate-950 overflow-hidden">
      {/* Animated Gradient Waves Background */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Wave 1 */}
        <div className="absolute w-full h-full">
          <div className="wave-animation wave-1"></div>
        </div>
        
        {/* Wave 2 */}
        <div className="absolute w-full h-full">
          <div className="wave-animation wave-2"></div>
        </div>
        
        {/* Wave 3 */}
        <div className="absolute w-full h-full">
          <div className="wave-animation wave-3"></div>
        </div>

        {/* Geometric Shapes */}
        <div className="geometric-shape shape-1"></div>
        <div className="geometric-shape shape-2"></div>
        <div className="geometric-shape shape-3"></div>
        <div className="geometric-shape shape-4"></div>
        <div className="geometric-shape shape-5"></div>

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0 bg-slate-950/40"></div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center relative z-10">
        <div className="space-y-6 animate-fadeIn">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white drop-shadow-2xl">
            {profileData.name}
          </h1>
          <div className="h-12 sm:h-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-cyan-400 drop-shadow-lg">
              {displayText}
              <span className="animate-pulse">|</span>
            </h2>
          </div>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mt-6 drop-shadow-lg">
            Building innovative, scalable, and user-centric software solutions
          </p>
          <div className="flex flex-wrap gap-4 justify-center mt-8">
            <button
              onClick={scrollToAbout}
              className="px-8 py-3 bg-cyan-500 text-white rounded-lg font-semibold hover:bg-cyan-600 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-cyan-500/50"
            >
              Learn More
            </button>
            <a
              href={`mailto:${profileData.email}`}
              className="px-8 py-3 border-2 border-cyan-500 text-cyan-500 rounded-lg font-semibold hover:bg-cyan-500 hover:text-white transform hover:scale-105 transition-all duration-300"
            >
              Contact Me
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <ChevronDown className="text-cyan-400" size={32} />
      </div>
    </section>
  );
};

export default Hero;
